// extracted by mini-css-extract-plugin
module.exports = {"title":"ShareLinks_title__vuZ5H"};